import { useDataStore } from "@/store/dataStore";
import AppList from "../AppList";
import StatisticsCards from "../StatisticsCards";
import { Button } from "antd";

export default function Prover() {
  const isMobile = useDataStore((state) => state.isMobile);

  return (
    <div>
      {/* {isMobile ? (
        <div
          className="app-bg"
          style={{ backgroundImage: 'url("/bg2.svg")' }}
        ></div>
      ) : (
        <div
          className="app-bg"
          style={{ backgroundImage: 'url("/bg.svg")' }}
        ></div>
      )} */}
      <div className="content-top">
        {/* {isMobile && (
          <Button
            type="primary"
            className="contact-btn mobile-contact-btn"
            onClick={() =>
              window.open(
                "https://form.typeform.com/to/lduiliob?typeform-source=brevis.network"
              )
            }
          >
            Join Brevis Prover Network
            <img src="/arrow-right.svg" alt="arrow-right" />
          </Button>
        )} */}
        <div className="title-section">
          <div className="large-title">Brevis Prover Network</div>
        </div>
        <StatisticsCards />
      </div>
      <AppList />
    </div>
  );
}
